export { type ProductsListProps, default as ProductsList } from './ProductsList';
